var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datas)?_c('div',[_c('a',{attrs:{"href":'/duyurular/'+_vm.datas.subjectTypeIds[0]+'/'+_vm.datas.publishPlaceIds[0]+'/'+_vm.datas.id+'/'+_vm.datas.url}},[_c('div',[_c('div',[_c('img',{staticClass:"imgslider",attrs:{"src":_vm.datas.pageIconPath,"alt":""}})])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }